import SearchParamsBase from "../../../Elements/SearchParamsBase";
import InputTypesEnum from "../../../Enums/InputTypesEnum";

export default class LocationsAdminSearchParams extends SearchParamsBase
{
	initialize()
	{
		this.CuClientSassieId="";
		this.CuName="";
		this.CuCountry="";
		this.CuCity=""
		this.CuState="";
		this.CuCcid="";
		this.BravoClientNameOrApolloId="";
	}

	//-------------------------------------------
	//-------- Fields for Search Panel ----------
	//-------------------------------------------

	static fieldsInSearchBox=[
		{fieldName:"BravoClientNameOrApolloId",label:"Bravo Client Name or Apollo Client ID", className:"col-3", type: InputTypesEnum.Text},
		{fieldName:"CuName",label:"Location Name or Apollo Location Database ID", className:"col-3", type: InputTypesEnum.Text},
		{fieldName:"CuUserLocId",label:"User Location ID", className:"col-3", type: InputTypesEnum.Text},
		{fieldName:"CuCountry",label:"Location Country", className:"col-3", type: InputTypesEnum.CountrySelect},
		{fieldName:"CuCity",label:"Location City", className:"col-3", type: InputTypesEnum.Text},
        {fieldName:"CuState",label:"Location State", className:"col-3", type: InputTypesEnum.Text},
	];

	static iconName="fa-solid fa-search";
	static saveType = "LocationsAdminSearchParams";
	//---------------------------
	
}